/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseVideoTutorial } from '../../models/api-response-video-tutorial';

export interface GetVideoTutorialByLang$Params {
  lang: string;
  name: string;
}

export function getVideoTutorialByLang(http: HttpClient, rootUrl: string, params: GetVideoTutorialByLang$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVideoTutorial>> {
  const rb = new RequestBuilder(rootUrl, getVideoTutorialByLang.PATH, 'get');
  if (params) {
    rb.path('lang', params.lang, {});
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseVideoTutorial>;
    })
  );
}

getVideoTutorialByLang.PATH = '/v1/api/video-tutorial-client/{lang}/{name}';
